import React from 'react';

const TaskFormIcon = ({iconName}) => {
    return (
        <img
            className='mr-2'
            title="refresh"
            src={`${process.env.PUBLIC_URL}/assets/icons/${iconName}`}
            alt="refresh"
            style={{ width: '15px', height: '18px'}}
        />
    );
};

export default TaskFormIcon;
